import { createAction, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { createExtendedSlice } from '../createExtendedSlice';
import { ApiReducerState, WidgetDataFetch } from './types';
import { RootState } from '../../../store';
import { LogMsgFailed } from 'src/app/store/routingSlice/types';

const sliceName = 'apiSlice';

// 4 state statuses (assets / snapshot):
// 1. undefined === initial
// 2. null === fetching
// 3. empty array === no data
// 4. array with items === with data
const initialState: ApiReducerState = {
  data: {},
};
// =============================
// ------- Slice ----------
// =============================
export const apiViewSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {
    // ---- Internal ---
    apiViewUpdateData: (state, { payload }: PayloadAction<[string, any]>) => {
      const [key, data] = payload;
      state.data[key] = data;
    },
  },
});

export const apiOnWidgetFetchData = <T>() =>
  createAction<WidgetDataFetch<T>>(`${sliceName}/apiOnWidgetFetchData`);
export const apiOnWidgetFetchDataFailed = createAction<LogMsgFailed>(
  `${sliceName}/apiOnWidgetFetchDataFailed`,
);

// =============================
// ------- selectors ----------
// =============================
export const getAiData = (state: RootState) => state.widgets.data;
export const getRelevantAiData = createSelector(
  getAiData,
  (_: any, dataKey: string) => dataKey,
  (data, dataKey) => {
    return data[dataKey] ?? null;
  },
);
// =============================
// ------- Exports ----------
// =============================

export const { apiViewUpdateData } = apiViewSlice.actions;

export default apiViewSlice.reducer;
